// 會產生水桶（Block Period）紀錄的兩種 WAF 規則
export const WAF_BUCKET_TYPE = {
    BLOCK_PERIOD: "blockPeriod",
    DENY_THEN_BUCKET: "denyThenBucket",
};

/**
 * 判斷該 WAF 規則屬於哪一種水桶規則
 * 1. Action 為 Block Period(08)：命中即進入水桶
 * 2. Action 為 Deny(01) 且開啟「觸發 Period 阻擋」：命中後還要達到設定頻率才進入水桶
 *
 * 實際清除水桶由後端在編輯或刪除規則時執行，前端只負責變更前的提示
 *
 * @param {Object} rule WAF 規則資料（表格 row 或表單 formData）
 * @returns {String} WAF_BUCKET_TYPE 的值，非水桶規則回傳空字串
 */
export function getWafBucketType(rule) {
    if (!rule) return "";
    if (rule.wafAction == "08") return WAF_BUCKET_TYPE.BLOCK_PERIOD;
    if (rule.wafAction == "01" && !!rule.wafIsDenyThenBucket) {
        return WAF_BUCKET_TYPE.DENY_THEN_BUCKET;
    }
    return "";
}

/**
 * 是否為會產生水桶紀錄的規則
 * @param {Object} rule WAF 規則資料
 * @returns {Boolean}
 */
export function isWafBucketRule(rule) {
    return getWafBucketType(rule) !== "";
}

/**
 * 取得變更前提示要使用的 i18n key
 * @param {Object} rule WAF 規則資料
 * @param {String} action edit 或 delete
 * @returns {String} i18n key，非水桶規則回傳空字串
 */
export function getWafBucketNoticeKey(rule, action) {
    const type = getWafBucketType(rule);
    if (!type) return "";
    const suffix = type === WAF_BUCKET_TYPE.BLOCK_PERIOD ? "BlockPeriod" : "DenyThenBucket";
    return `wafrules.clearBucketOn${action === "delete" ? "Delete" : "Edit"}${suffix}Text`;
}

export default { WAF_BUCKET_TYPE, getWafBucketType, isWafBucketRule, getWafBucketNoticeKey };



// WEBPACK FOOTER //
// ./src/libs/wafBucket.js